import { IGame } from "@grassrootly/api/entities/IGame";
import { ISearchQuery } from "@grassrootly/api/entities/ISearchQuery";
import { provider } from "@grassrootly/api/providers";

export type GetPlayerGamesPayload = ISearchQuery & {
  playerId: number;
  skip?: number;
  take?: number;
};

export const GetPlayerGames = async (params: GetPlayerGamesPayload): Promise<IGame[]> =>
  provider.Request("/players/{id}/games", params);
